<template>
  <div class="lg:!mx-0 flex">
    <div class="flex flex-col max-h-content px-6 pb-2.5 min-h-content space-y-2.5 mx-auto w-full max-w-xl">
      <!-- Header Section -->
      <div class="mt-2.5">
        <div class="flex items-center justify-between element-island">
          <div>
            <h1 class="text-3xl font-bold text-gray-900">
              {{ $t('ProjectDailyRates.title') }}
            </h1>

            <p class="mt-2 text-sm text-gray-600">
              {{ $t('ProjectDailyRates.subTitle') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="flex flex-col space-y-4 w-full">
        <template v-if="wbsCodes.length">
          <!-- Form Section -->
          <div class="bg-white rounded-lg shadow-sm border border-gray-200 flex-1 flex flex-col">
            <div class="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-1.5 border-b border-gray-200 rounded-t-lg">
              <div class="flex items-center space-x-3">
                <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-5 h-5 text-blue-600">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>
                </div>

                <h2 class="text-lg font-semibold text-gray-900">
                  {{ $t('ProjectDailyRates.analysisTitle') }}
                </h2>
              </div>
            </div>

            <div class="p-6 space-y-6">
              <form
                action=""
                class="space-y-6"
                @submit.prevent="fetchMetrics"
              >
                <!-- WBS Code Selection -->
                <div class="space-y-2">
                  <label class="block text-sm font-medium text-gray-700">
                    {{ $t('ProjectDailyRates.label.wbsCode') }}
                  </label>

                  <AppSelect
                    v-model.number="wbs_code_id"
                    :options="wbsCodes.map((code) => ({ value: code.id, label: code.code }))"
                    name="wbs_code"
                    data-test="wbs_code"
                    class="form-input"
                  />
                </div>

                <!-- WBS Description -->
                <div class="space-y-2">
                  <label class="block text-sm font-medium text-gray-700">
                    {{ $t('ProjectDailyRates.label.wbsDescription') }}
                  </label>

                  <AppSelect
                    v-model.number="wbs_code_id"
                    :options="wbsCodes.map((code) => ({ value: code.id, label: code.description }))"
                    name="wbs_code_description"
                    data-test="wbs_code_description"
                    class="form-input"
                  />
                </div>

                <!-- Unit Display -->
                <div
                  v-if="wbsCode"
                  class="flex justify-between items-center p-3 bg-gray-50 rounded-lg border border-gray-200"
                >
                  <span class="text-sm font-medium text-gray-700">
                    {{ $t('ProjectDailyRates.label.unit') }}
                  </span>

                  <span class="text-sm text-gray-900 font-semibold">
                    {{ wbsCode.unit }}
                  </span>
                </div>

                <!-- Date Selection -->
                <div class="flex items-center space-x-3 w-full justify-center">
                  <button
                    type="button"
                    class="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                    data-test="prev-day"
                    @click="prevDate"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-600">
  <path fill-rule="evenodd" d="M7.72 12.53a.75.75 0 010-1.06l7.5-7.5a.75.75 0 111.06 1.06L9.31 12l6.97 6.97a.75.75 0 11-1.06 1.06l-7.5-7.5z" clip-rule="evenodd" />
</svg>
                  </button>

                  <AppInput
                    ref="selectDateInput"
                    v-model="day"
                    class="form-input"
                    type="date"
                    name="day"
                    data-test="day"
                  />

                  <button
                    type="button"
                    class="p-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                    data-test="next-day"
                    @click="nextDate"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 text-gray-600">
  <path fill-rule="evenodd" d="M16.28 11.47a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 01-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 011.06-1.06l7.5 7.5z" clip-rule="evenodd" />
</svg>
                  </button>
                </div>

                <!-- Fetch Button -->
                <button
                  type="submit"
                  :disabled="averageAction.state.value === States.LOADING"
                  class="w-full btn btn--primary-blue flex items-center justify-center space-x-2"
                >
                  <svg
    fill="none"
    viewBox="0 0 24 24"
 v-if="averageAction.state.value === States.LOADING"
                   
                    class="animate-spin h-5 w-5 text-white">
    <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
    />

    <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
</svg>

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-else
                   
                    class="w-5 h-5">
  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
</svg>

                  <span>{{ averageAction.state.value === States.LOADING ? $t('ProjectDailyRates.button.fetching') : $t('ProjectDailyRates.button.fetch') }}</span>
                </button>
              </form>

              <template v-if="averageAction.state.value === States.COMPLETE && wbsCode">
                <div class="flex justify-between items-center p-4 bg-blue-50 rounded-lg border border-blue-200">
                  <div class="flex items-center space-x-3">
                    <div class="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-7 h-7 text-blue-600">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
</svg>
                    </div>

                    <span class="text-sm font-medium text-gray-700">
                      {{ $t('ProjectDailyRates.metrics.tenderProductionRate') }}
                    </span>
                  </div>

                  <span class="text-lg font-semibold text-blue-900">
                    {{ australianCurrency(wbsCode.unitCost) }}/{{ wbsCode.unit }}
                  </span>
                </div>

                <!-- Average Production Rate -->
                <div class="flex justify-between items-center p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div class="flex items-center space-x-3">
                    <div class="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-4 h-4 text-gray-600">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>
                    </div>

                    <span class="text-sm font-medium text-gray-700">
                      {{ $t('ProjectDailyRates.metrics.averageProductionRate') }}
                    </span>
                  </div>

                  <span
                    v-if="metrics.average_quantity === 0"
                    class="text-lg font-semibold text-gray-500"
                  >
                    {{ $t('ProjectDailyRates.notAvailable') }}
                  </span>

                  <span
                    v-else
                    :class="[
                      'text-lg font-semibold',
                      metrics.average_cost / metrics.average_quantity > wbsCode.unitCost
                        ? 'text-red-600'
                        : 'text-green-600'
                    ]"
                  >
                    {{ australianCurrency(metrics.average_cost / metrics.average_quantity) }}/{{ wbsCode.unit }}
                  </span>
                </div>

                <!-- Daily Production Rate -->
                <div class="flex justify-between items-center p-4 bg-gray-50 rounded-lg border border-gray-200">
                  <div class="flex items-center space-x-3">
                    <div class="w-6 h-6 bg-gray-100 rounded-full flex items-center justify-center">
                      <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    />
</svg>
                    </div>

                    <span class="text-sm font-medium text-gray-700">
                      {{ $t('ProjectDailyRates.metrics.dailyProductionRate') }}
                    </span>
                  </div>

                  <span
                    v-if="metrics.daily_quantity === 0 || metrics.daily_cost === 0"
                    class="text-lg font-semibold text-gray-500"
                  >
                    {{ $t('ProjectDailyRates.notAvailable') }}
                  </span>

                  <span
                    v-else
                    :class="[
                      'text-lg font-semibold',
                      metrics.daily_cost / metrics.daily_quantity > wbsCode.unitCost
                        ? 'text-red-600'
                        : 'text-green-600'
                    ]"
                  >
                    {{ australianCurrency(metrics.daily_cost / metrics.daily_quantity) }}/{{ wbsCode.unit }}
                  </span>
                </div>
              </template>

              <div
                v-else-if="averageAction.state.value === States.LOADING"
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
              >
                <div class="flex items-center justify-center space-x-3">
                  <AppSpinner />

                  <span class="text-sm text-gray-600">{{ $t('ProjectDailyRates.loading') }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Empty State -->
        <div
          v-else
          class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
        >
          <div class="px-6 py-16 text-center">
            <div class="mx-auto h-12 w-12 text-gray-300 mb-4">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"  class="w-12 h-12">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
</svg>
            </div>

            <h3 class="text-sm font-medium text-gray-900 mb-1">
              {{ $t('ProjectDailyRates.emptyState.noWbsCodesFound') }}
            </h3>

            <p class="text-sm text-gray-500">
              {{ $t('ProjectDailyRates.emptyState.noWbsCodesMessage') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useDayQueryParam from '@/composables/useDayQueryParam';
import { useProjectTypeRedirect } from '@/composables/useProjectTypeRedirect';
import useScreenSize from '@/composables/useScreenSize';
import { ScreenSize } from '@/composables/useScreenSize';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency } from '@/helpers';
import { useNavStore } from '@/store/nav';
import { useProjectsStore } from '@/store/projects';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { computed, reactive, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  projectId: string;
}>();

const projectsStore = useProjectsStore();
const wbsCodesStore = useWbsCodesStore();

const project = computed(() => {
  return projectsStore.project;
});

const wbs_code_id = ref();
const queryDate = useDayQueryParam();
const day = ref(queryDate.value.toISOString().slice(0, 10));

const metrics = reactive({
  average_cost: 0,
  average_quantity: 0,
  daily_cost: 0,
  daily_quantity: 0,
});

const averageAction = useStoreApiAction(projectsStore.wbsCodeAverage);

const fetchMetrics = () => {
  if(wbs_code_id.value) {
    averageAction.request(props.projectId, { wbs_code: wbs_code_id.value, day: day.value })
      .then((averageMetrics) => {
        metrics.average_cost = averageMetrics.average_cost;
        metrics.average_quantity = averageMetrics.average_quantity;
        metrics.daily_cost = averageMetrics.daily_cost;
        metrics.daily_quantity = averageMetrics.daily_quantity;
      }).catch((error) => {
        console.error(error);
      });
  }
};

watch(() => props.projectId, (newValue) => {
  if(newValue) {
    wbsCodesStore.index(newValue).then((codes) => {
      wbs_code_id.value = codes[0]?.id;
      fetchMetrics();
    });
  }
}, { immediate: true });

const wbsCodes = computed(() => {
  return wbsCodesStore.models.where('project_id', project.value?.id).get();
});

const wbsCode = computed(() => {
  return wbsCodesStore.models.find(wbs_code_id.value);
});

const { screenSize } = useScreenSize();
const navStore = useNavStore();

if(screenSize.value < ScreenSize.MD) {
  navStore.backRoute = { name: 'MobileProjectPage' };
}

const nextDate = () => {
  const nextDay = new Date(day.value);

  nextDay.setDate(nextDay.getDate() + 1);
  day.value = nextDay.toISOString().slice(0, 10);
};

const prevDate = () => {
  const nextDay = new Date(day.value);

  nextDay.setDate(nextDay.getDate() - 1);
  day.value = nextDay.toISOString().slice(0, 10);
};

const router = useRouter();

watch(day, () => {
  router.replace({ query: { day: day.value } });
}, { immediate: true });

watch([day, wbs_code_id], () => {
  fetchMetrics();
});

useProjectTypeRedirect();
</script>

<style scoped></style>
